import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { HOME } from "@/constants/testIds";
import Report from "@/pages/Report";
import ReportPrint from "@/pages/ReportPrint";
import ExecutiveSummary from "@/pages/ExecutiveSummary";
import ExecutiveSummaryPrint from "@/pages/ExecutiveSummaryPrint";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div>
      <header className="App-header">
        <a
          data-testid={HOME.emergentLink}
          className="App-link"
          href="https://emergent.sh"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4" />
        </a>
        <p className="mt-5">Building something incredible ~!</p>
      </header>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/report" replace />} />
          <Route path="/home" element={<Home />} />
          <Route path="/report" element={<Report />} />
          <Route path="/report/print" element={<ReportPrint />} />
          <Route path="/executive-summary" element={<ExecutiveSummary />} />
          <Route path="/executive-summary/print" element={<ExecutiveSummaryPrint />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
